const PRIMARY_COLOR = '#FF7300';
const FORM_BG_COLOR = '#161718';
const PRIMARY_COLOR_ALPHA = '#FF73004D';

export { FORM_BG_COLOR, PRIMARY_COLOR, PRIMARY_COLOR_ALPHA };

